import React, { useEffect, useState } from 'react';
import { Route, Routes } from 'react-router-dom';
import ApiDocs from './ApiDocs';
import Home from './Home';
import apiVersions from './model/apiversions.json';
import { HelpItem } from './model/HelpItem';
import { HelpItemManager } from './model/HlelpItemManager';
import PageNotFound from './PageNotFound';

function getDefaultTheme() {
    const darkMode = localStorage.getItem('darkMode');
    if (darkMode) {
        return JSON.parse(darkMode);
    }
    return false;
}

function getDefaultVersion() {
    const version = localStorage.getItem('version');
    if (version) {
        return JSON.parse(version);
    }
    return apiVersions.versions[apiVersions.versions.length - 1];
}
  
const App: React.FC = () => {
    const [helpItems, setHelpItems] = useState<HelpItem[]>([]);
    const [apiVersion, setApiVersion] = useState(getDefaultVersion);
    const [darkMode, setDarkMode] = useState(getDefaultTheme);
    const versions = apiVersions.versions;


    useEffect(() => {
        const loadData = async () => {
            if (apiVersion === '') {
                return;
            }
            try {
                const response = await fetch(`/data/revitapi${apiVersion}.json`);
                const jsonData = await response.json();
                setHelpItems(jsonData.children);
                HelpItemManager.getInstance().initializeFlattenedItems(jsonData.children);
            } catch (error) {
                setHelpItems([])
            }          
        };
    
        loadData();
      }, [apiVersion]);
    const handleVersionChange = (version: string) => {
        setApiVersion(version); 
        localStorage.setItem('version', JSON.stringify(version));
    };
    const handleDarkModeChange = () => {
        setDarkMode(!darkMode);
        localStorage.setItem('darkMode', JSON.stringify(!darkMode));
    }     
    return (
        <Routes>
            <Route path="/*" element={<Home apiVersion={apiVersion} versions={versions} darkMode={darkMode} handleDarkModeChange={handleDarkModeChange} handleVersionChange={handleVersionChange}/>} />
            <Route path="/:version/*" element={<ApiDocs apiVersion={apiVersion} handleVersionChange={handleVersionChange} darkMode={darkMode} handleDarkModeChange = {handleDarkModeChange} versions={versions} helpItems={helpItems}/>} />
            <Route path="*" element={<PageNotFound />} />
        </Routes>
    );
};

export default App;